/**
 * EventEmitter
 * Custom pub/sub event system. Base class for Sizes, Time, and Resources.
 * Provides on(), off(), and trigger() methods for decoupled communication.
 */
export default class EventEmitter {
    constructor() {
        this.callbacks = {}
        this.callbacks.base = {}
    }

    on(_names, callback) {
        if (typeof _names === 'undefined' || _names === '') return false
        if (typeof callback === 'undefined') return false

        const names = this.resolveNames(_names)
        names.forEach((_name) => {
            const name = this.resolveName(_name)
            if (!this.callbacks[name.namespace]) this.callbacks[name.namespace] = {}
            if (!this.callbacks[name.namespace][name.value]) this.callbacks[name.namespace][name.value] = []
            this.callbacks[name.namespace][name.value].push(callback)
        })

        return this
    }

    off(_names) {
        if (typeof _names === 'undefined' || _names === '') return false

        const names = this.resolveNames(_names)
        names.forEach((_name) => {
            const name = this.resolveName(_name)
            if (name.namespace !== 'base' && name.value === '') {
                delete this.callbacks[name.namespace]
            } else {
                if (name.namespace === 'base') {
                    for (const namespace in this.callbacks) {
                        if (this.callbacks[namespace][name.value]) {
                            delete this.callbacks[namespace][name.value]
                        }
                    }
                } else if (this.callbacks[name.namespace] && this.callbacks[name.namespace][name.value]) {
                    delete this.callbacks[name.namespace][name.value]
                }
            }
        })

        return this
    }

    trigger(_name, _args) {
        if (typeof _name === 'undefined' || _name === '') return false

        let finalResult = null
        let result = null

        const names = this.resolveNames(_name)
        names.forEach((_name) => {
            const name = this.resolveName(_name)
            for (const namespace in this.callbacks) {
                if (this.callbacks[namespace][name.value]) {
                    this.callbacks[namespace][name.value].forEach((callback) => {
                        result = callback.apply(this, _args || [])
                        if (typeof result !== 'undefined') finalResult = result
                    })
                }
            }
        })

        return finalResult
    }

    resolveNames(_names) {
        let names = _names
        names = names.replace(/[^a-zA-Z0-9 ,/.]/g, '')
        names = names.replace(/[,/]+/g, ' ')
        names = names.split(' ')
        return names
    }

    resolveName(name) {
        const parts = name.split('.')
        return {
            original: name,
            value: parts[0],
            namespace: parts.length > 1 && parts[1] !== '' ? parts[1] : 'base'
        }
    }
}
